import { Switch, Route } from 'react-router';

import MailingLists from './table';

export const MailingListsDomain = () => {
  return (
    <Switch>
      <Route exact path="/mailing-lists/" component={MailingLists} />
    </Switch>
  );
};
